import React from 'react'
import PettyCashDeleteReport from '../components/PettyCash/PettyCashDeleteReport'



export default function ExpenceDelete() {
  return (
    <div className="layout-body">
      <PettyCashDeleteReport />
    </div>
  )
}
